import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes'
import { PageTitle } from '@src/api/common/PageTitleType'

const Breadcrumbs: Array<BreadcrumbItem> = [
    {
        title: 'Impersonation',
        isLink: false
    },
]

const Title: PageTitle = {
    title: 'Impersonation',
}

export { Breadcrumbs, Title };